export default __webpack_public_path__ + "static/media/Thief's Tunic of the Burning Temple.eee521a8.jpg";